(function ($) {

'use strict';

	/**
	 * Loads the datepicker.min.js if required and execute the done function
	 * when ready
	 * @param {function} doneFunc
	 * @returns {undefined}
	 */
	$.loadDatepickerJs = function (doneFunc) {

		/**
		 * check if the doneFunc could run
		 */
		function loadedNow() {
			if (!$.loadDatepickerActive) {
				doneFunc();
			} else {
				setTimeout(loadedNow, 100);
			}
		}

		if (typeof $.fn.datepicker !== 'function' && !$.loadDatepickerActive) {
			// set loading status
			$.loadDatepickerActive = true;
			// try to load datepicker.min.js
			var jsFile = '/js/datepicker/datepicker.min.js';
			$.cachedScript(jsFile).done(function () {
				
				// dynamically loads the CSS
				$.ajax({
					url: '/js/datepicker/datepicker.min.css?v=' + new Date().getTime(),
					type: 'GET',
					dataType: 'text',
					success: function (cssData) {
						$('head').prepend($('<style type="text/css">\n' + cssData + '</style>'));

						var langFiles = {
							'cs': 'cs-CZ',
							'cz': 'cs-CZ',
							'de': 'de-DE',
							'es': 'es-ES',
							'hu': 'hu-HU',
							'it': 'it-IT',
							'pt': 'pt-BR',
							'sk': 'sk-SK'
						};

						var activeLang = $('html').attr('lang');
						$.datepickerLang = 'en-US'; // !! ALWAYS insert this into the datepicker init object
						if(activeLang !== 'en'){
							$.datepickerLang = langFiles[activeLang];
							$.cachedScript('/js/datepicker/i81n/datepicker.' + langFiles[activeLang] + '.js').done(function () {
								if (typeof doneFunc === 'function') {
									doneFunc();			
									
									// clear loading status
									delete $.loadDatepickerActive;
								}
							});
						}else if(typeof doneFunc === 'function'){
							doneFunc();

							// clear loading status
							delete $.loadDatepickerActive;
						}
					}
				});
			}).fail(function (jqxhr, settings, exception) {
				console.log(jsFile + ' ! ' + exception);
			});
		} else if (typeof doneFunc === 'function') {
			loadedNow();
		}
	};	// $.loadLightboxJs

}(jQuery));